import React from "react";
import moment from "moment-timezone";
function numberWithCommas(x) {
    if(x){
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    else{
        return "0.00"
    }
}
export const ApiLogsColumn = (userinfo,ActiveInActiveCoupon,name) => {

    let columns = [
        {
            Header: 'API Endpoint',
            accessor: 'endpoint',
            className: "align-middle text-nowrap text-center",
            Cell: (row) => {
                return (
                    <>
                        {row.value || "-"}
                    </>
                );
            },
        },
        {
            Header: 'Request Parameter',
            accessor: 'request_body',
            className: "align-middle text-nowrap text-center",
            Cell: (row) => {
                return (
                    <>
                        {row.value || "-"}
                    </>
                );
            },
        },
        {
            Header: "Created Date",
            accessor: "timestamp",
            className: "text-center text-capitalize text-nowrap",
            Cell: ({ value }) => {
                return (
                    <>
                        <div>
                            {value ? moment.tz(value, userinfo.timezone).format("YYYY-MM-DD") : "-"}
                        </div>
                        <div className="small text-muted">
                            {value ? moment.tz(value, userinfo.timezone).format("HH:mm:ss") : "-"}
                        </div>
                    </>
                );
            },
        }
    ];
    return columns;

}
